module.exports = __webpack_public_path__ + "images/marketing/features/connect3.png";